<template>
	<v-carousel cycle hide-delimiter-background show-arrows-on-hover>
		<v-carousel-item
			v-for="(slide, i) in sliders"
			:key="i"
			:src="slide.image_url"
		>
			<v-main class="align-center ml-15">
				<v-card flat max-width="400" elevation="14">
					<v-card-title primary-title>
						{{ slide.slider_title }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						{{ slide.slider_description }}
					</v-card-text>
				</v-card>
			</v-main>
		</v-carousel-item>
	</v-carousel>
</template>

<script>
	export default {
		props: ["sliders"],
	};
</script>